import React, { Component } from 'react'

import edit from '../../../../assets/icons/edit.svg';

import './SettingItem.css';

export default class SettingItem extends Component {
  render() {
    const { settings } = this.props;
    return (
      <div className="mobile-setting-item d-flex" onClick={() => this.props.openModal(settings.modal)}>
        <div className="mobile-setting-item__right d-flex">
          <img src={settings.icon} />
          <div>{settings.label}</div>
        </div>
        <div className="mobile-setting-item__left d-flex flex-row-reverse">
          <img src={edit} />
          <div>{settings.value ? settings.value : settings.placeholder}</div>
        </div>
      </div>
    );
  }
}